<mat-progress-spinner
  mode="determinate"
  class="background"
  [diameter]="diameter"
  [strokeWidth]="width || '10%'"
  [color]="color"
  [value]="100"
></mat-progress-spinner>
<mat-progress-spinner
  *ngFor="let bar of displayBars"
  mode="determinate"
  class="color-{{ bar.color }}"
  [diameter]="diameter"
  [strokeWidth]="width || '10%'"
  [color]="bar.color"
  [value]="(bar.value / (max || 1)) * 100"
></mat-progress-spinner>
